import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { privacyPolicyApi, PrivacyPolicyPayload } from '@/api/privacyPolicy';
import { useActionFeedback } from '@/hooks/useActionFeedback';

export const usePrivacyPolicy = (enabled = true) =>
  useQuery({
    queryKey: ['privacy-policy'],
    queryFn: () => privacyPolicyApi.get(),
    enabled,
  });

export const useCreatePrivacyPolicy = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: PrivacyPolicyPayload) => privacyPolicyApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['privacy-policy'] });
      feedback.success('Privacy policy berhasil dibuat');
    },
    onError: (error) => {
      feedback.error('Gagal membuat privacy policy', error);
    },
  });
};

export const useUpdatePrivacyPolicy = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: PrivacyPolicyPayload) => privacyPolicyApi.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['privacy-policy'] });
      feedback.success('Privacy policy berhasil diperbarui');
    },
    onError: (error) => {
      feedback.error('Gagal memperbarui privacy policy', error);
    },
  });
};

export const useDeletePrivacyPolicy = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: () => privacyPolicyApi.delete(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['privacy-policy'] });
      feedback.success('Privacy policy berhasil dihapus');
    },
    onError: (error) => {
      feedback.error('Gagal menghapus privacy policy', error);
    },
  });
};